import { getRequest } from '../services/requestHandler';
import { HandLookup } from '../models';

export const getHandLookups = async () => {
  const url = 'lookup/getHands';
  const response = await getRequest<HandLookup>('GetHandLookups', url);
  return response;
};
